import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  MenuItem,
  IconMenu,
} from 'material-ui';
import Icon from 'material-ui/svg-icons/action/language';

import { changeLocale as changeLocaleAction } from 'admin-on-rest';

const LocaleSwitcher = ({ changeLocale, locale }) => {
  const changeLocaleFn = (loc) => {
    localStorage.setItem('saved_locale', loc);
    return changeLocale(loc);
  };
  return (
    <IconMenu
      width="256px"
      style={{ display: 'block' }}
      iconButtonElement={<MenuItem primaryText="Language" leftIcon={<Icon />} />}
    >
      <MenuItem primaryText="English" onClick={() => changeLocaleFn('en')} checked={locale === 'en'} />
      <MenuItem primaryText="Svenska" onClick={() => changeLocaleFn('sv')} checked={locale === 'sv'} />
      <MenuItem primaryText="Norsk" onClick={() => changeLocaleFn('nb')} checked={locale === 'nb'} />
      <MenuItem primaryText="Dansk" onClick={() => changeLocaleFn('da')} checked={locale === 'da'} />
    </IconMenu>
  );
};

LocaleSwitcher.propTypes = {
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({ locale: state.locale });

export default connect(mapStateToProps, { changeLocale: changeLocaleAction })(LocaleSwitcher);
